<template>
  <v-container>
    <v-row v-for="(n, i) in row" :key="i">
      <v-col v-for="(m, j) in column" :key="j" cols="cols">
        <v-card
          v-if="items[column * i + j] !== undefined"
          outlined
          elevation="3"
          :min-height="minHeight"
        >
          <h3 class="pa-5">
            {{ title(column * i + j) }}
          </h3>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    minHeight: "120",
    row: 6,
    column: 3,
    cols: 4,
    items: [
      { title: "Оценка инновационности ИТЗ" },
      { title: "Сопоставление аналогов ИТЗ" },
      { title: "Сопоставление ИТЗ по профилям медицинской помощи" },
      { title: "Сопоставление ИТЗ по факторной направленности " },
      { title: "Сопоставление ИТЗ по целевым группам факторов риска ОНИЗ" },
      { title: "Моделирование управляющих воздействий" },
      { title: "Оценка клинической эффективности" },
      { title: "Оценка социальной эффективности" },
      { title: "Оценка экономической эффективности" },
      { title: "Оценка практичности применения" },
      { title: 'Сопоставление приоритетов, "радикальные" ИТЗ' },
      { title: "Интеграционная оценка" },
    ],
  }),
  methods: {
    title(index) {
      return this.items[index].title;
    },
  },
};
</script>
